"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _TreeViewItem = require("./components/TreeViewItem/TreeViewItem");
var _useTeamsFiles2 = require("@/hooks/useTeamsFiles");
var _treeBuilder = require("@/utils/treeBuilder");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// Internal tree node type

var TreeView = exports.TreeView = function TreeView(_ref) {
  var showSelectAll = _ref.showSelectAll,
    showDivider = _ref.showDivider;
  var _useTeamsFiles = (0, _useTeamsFiles2.useTeamsFiles)(),
    selectedRows = _useTeamsFiles.selectedRows,
    getTeamsFilesByParentId = _useTeamsFiles.getTeamsFilesByParentId,
    getSelectedFiles = _useTeamsFiles.getSelectedFiles,
    updateTeamsFile = _useTeamsFiles.updateTeamsFile,
    getTeamsFileById = _useTeamsFiles.getTeamsFileById,
    _teamsFiles = _useTeamsFiles.teamsFiles;

  // Build internal tree using the utility
  var treeNodes = (0, _react.useMemo)(function () {
    var selectedFiles = getSelectedFiles();
    return (0, _treeBuilder.buildTreeFromSelectedFiles)(selectedFiles, getTeamsFilesByParentId, getTeamsFileById, function (file, level) {
      return {
        id: file.id,
        name: file.name,
        folder: !!file.folder,
        category: file.category || null,
        selected: file.selected,
        level: level
      };
    });
  }, [getSelectedFiles, getTeamsFilesByParentId, getTeamsFileById]);
  // Helper function to find a node in the internal tree
  var findNodeInTree = (0, _react.useCallback)(function (nodeId, nodes) {
    var _iterator = _createForOfIteratorHelper(nodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var node = _step.value;
        if (node.id === nodeId) return node;
        var found = findNodeInTree(nodeId, node.children);
        if (found) return found;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return null;
  }, []);

  // Helper function to find children of a node in the internal tree
  var findChildrenInTree = (0, _react.useCallback)(function (parentId, nodes) {
    var parent = findNodeInTree(parentId, nodes);
    return parent ? parent.children : [];
  }, [findNodeInTree]);

  // Function to update parent selection based on its children
  var updateParentSelectionRecursively = (0, _react.useCallback)(function (parentId, childId, childWillBeSelected) {
    var _parent$parentReferen3;
    var parent = getTeamsFileById(parentId);
    if (!(parent !== null && parent !== void 0 && parent.folder)) return;

    // KEY: Only work with children that are in our internal tree
    var treeChildren = findChildrenInTree(parentId, treeNodes);

    // If there are no children in the tree, do nothing
    if (treeChildren.length === 0) {
      var _parent$parentReferen;
      // But still continue upward just in case
      if ((_parent$parentReferen = parent.parentReference) !== null && _parent$parentReferen !== void 0 && _parent$parentReferen.id) {
        updateParentSelectionRecursively(parent.parentReference.id, parentId, parent.selected);
      }
      return;
    }

    // Check if all TREE children are selected
    var allTreeChildrenSelected = treeChildren.every(function (child) {
      // If this child is the one we're updating, use the future value
      if (childId && child.id === childId) {
        return childWillBeSelected !== null && childWillBeSelected !== void 0 ? childWillBeSelected : child.selected;
      }
      // For other children, use their current state
      return child.selected;
    });

    // Only update if the parent's state needs to change
    if (parent.selected !== allTreeChildrenSelected) {
      var _parent$parentReferen2;
      updateTeamsFile(parentId, {
        selected: allTreeChildrenSelected
      });

      // IMPORTANT: Continue recursively upward
      // The parent's parent also needs to be checked
      if ((_parent$parentReferen2 = parent.parentReference) !== null && _parent$parentReferen2 !== void 0 && _parent$parentReferen2.id) {
        updateParentSelectionRecursively(parent.parentReference.id, parentId, allTreeChildrenSelected);
      }
      return;
    }

    // IMPORTANT: Even if the parent didn't change, we must check upward
    // because the grandparent might need to be updated due to other changes
    if ((_parent$parentReferen3 = parent.parentReference) !== null && _parent$parentReferen3 !== void 0 && _parent$parentReferen3.id) {
      updateParentSelectionRecursively(parent.parentReference.id, parentId, parent.selected);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [updateTeamsFile, findChildrenInTree]);
  // Helper function to toggle descendants
  var toggleDescendants = (0, _react.useCallback)(function (parentId, selected) {
    updateTeamsFile(parentId, {
      selected: selected
    });

    // Get all parents of parentId going upward
    var getAllParents = function getAllParents(itemId) {
      var parents = [];
      var currentItem = getTeamsFileById(itemId);
      while ((_currentItem = currentItem) !== null && _currentItem !== void 0 && (_currentItem = _currentItem.parentReference) !== null && _currentItem !== void 0 && _currentItem.id) {
        var _currentItem;
        parents.push(currentItem.parentReference.id);
        currentItem = getTeamsFileById(currentItem.parentReference.id);
      }
      return parents;
    };
    var _getAllChildren = function getAllChildren(itemId) {
      var children = [];
      var directChildren = getTeamsFilesByParentId(itemId);
      var _iterator2 = _createForOfIteratorHelper(directChildren),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          children.push(child);
          if (child.folder) {
            children.push.apply(children, _toConsumableArray(_getAllChildren(child.id)));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return children;
    };
    var allParents = getAllParents(parentId);
    // Check if any of those parents exists in selectedRows
    var hasParentInSelectedRows = [parentId].concat(_toConsumableArray(allParents)).some(function (parentId) {
      return selectedRows.includes(parentId);
    });
    var children = _getAllChildren(parentId);
    var _iterator3 = _createForOfIteratorHelper(children.filter(function (child) {
        return child.folder;
      })),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var folder = _step3.value;
        toggleDescendants(folder.id, selected);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    if (!hasParentInSelectedRows) {
      //We need to filter only the selected ones
      children = children.filter(function (child) {
        return selectedRows.includes(child.id);
      });
    }
    var _iterator4 = _createForOfIteratorHelper(children),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var child = _step4.value;
        toggleDescendants(child.id, selected);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [updateTeamsFile, selectedRows]);

  // Simple toggle of selected - only change the state in teamsFiles
  var handleToggleItem = (0, _react.useCallback)(function (itemId, isChecked) {
    var _item$parentReference;
    var item = getTeamsFileById(itemId);
    if (item !== null && item !== void 0 && item.folder) {
      // If it's a folder, toggle all descendants
      toggleDescendants(itemId, isChecked);
    } else {
      // If it's a file, only toggle this file
      updateTeamsFile(itemId, {
        selected: isChecked
      });
    }

    // After updating, check if the parent should be automatically selected
    // Pass the future state to avoid synchronization issues
    if (item !== null && item !== void 0 && (_item$parentReference = item.parentReference) !== null && _item$parentReference !== void 0 && _item$parentReference.id) {
      updateParentSelectionRecursively(item.parentReference.id, itemId, isChecked);
    }
  }, [getTeamsFileById, updateTeamsFile, updateParentSelectionRecursively, toggleDescendants]);

  // Render tree recursively
  var renderTreeNodes = (0, _react.useCallback)(function (nodes) {
    return nodes.map(function (node) {
      return /*#__PURE__*/_react["default"].createElement(_TreeViewItem.TreeViewItem, {
        key: node.id,
        label: node.name,
        type: node.folder ? "folder" : "file",
        level: node.level,
        category: node.category || null,
        isChecked: node.selected,
        isIndeterminate: false,
        onCheckboxChange: function onCheckboxChange(checked) {
          return handleToggleItem(node.id, checked);
        }
      }, node.children.length > 0 && renderTreeNodes(node.children));
    });
  }, [handleToggleItem]);

  // Helper function to get all IDs from the internal tree
  var getAllTreeNodeIds = (0, _react.useCallback)(function (nodes) {
    var ids = [];
    var _collectIds = function collectIds(nodeList) {
      var _iterator5 = _createForOfIteratorHelper(nodeList),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var node = _step5.value;
          ids.push(node.id);
          if (node.children.length > 0) {
            _collectIds(node.children);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    };
    _collectIds(nodes);
    return ids;
  }, []);
  var handleToggleAll = (0, _react.useCallback)(function (isChecked) {
    // Only affect files that are in the internal tree
    var treeNodeIds = getAllTreeNodeIds(treeNodes);
    var _iterator6 = _createForOfIteratorHelper(treeNodeIds),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var fileId = _step6.value;
        updateTeamsFile(fileId, {
          selected: isChecked
        });
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }, [getAllTreeNodeIds, treeNodes, updateTeamsFile]);
  var areAllSelected = (0, _react.useMemo)(function () {
    // Only check files from the internal tree
    var treeNodeIds = getAllTreeNodeIds(treeNodes);
    if (treeNodeIds.length === 0) return false;
    return treeNodeIds.every(function (nodeId) {
      var _file$selected;
      var file = getTeamsFileById(nodeId);
      return (_file$selected = file === null || file === void 0 ? void 0 : file.selected) !== null && _file$selected !== void 0 ? _file$selected : false;
    });
  }, [getAllTreeNodeIds, treeNodes, getTeamsFileById]);
  var selectedCount = (0, _react.useMemo)(function () {
    // Only count files from the internal tree that are selected
    var treeNodeIds = getAllTreeNodeIds(treeNodes);
    return treeNodeIds.filter(function (nodeId) {
      var _file$selected2;
      var file = getTeamsFileById(nodeId);
      return (_file$selected2 = file === null || file === void 0 ? void 0 : file.selected) !== null && _file$selected2 !== void 0 ? _file$selected2 : false;
    }).length;
  }, [getAllTreeNodeIds, treeNodes, getTeamsFileById]);
  var totalCount = (0, _react.useMemo)(function () {
    // Total files in the internal tree
    return getAllTreeNodeIds(treeNodes).length;
  }, [getAllTreeNodeIds, treeNodes]);
  var areSomeSelected = (0, _react.useMemo)(function () {
    var treeNodeIds = getAllTreeNodeIds(treeNodes);
    var someSelected = treeNodeIds.some(function (nodeId) {
      var _file$selected3;
      var file = getTeamsFileById(nodeId);
      return (_file$selected3 = file === null || file === void 0 ? void 0 : file.selected) !== null && _file$selected3 !== void 0 ? _file$selected3 : false;
    });
    return someSelected && !areAllSelected;
  }, [getAllTreeNodeIds, treeNodes, getTeamsFileById, areAllSelected]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, showSelectAll && getAllTreeNodeIds(treeNodes).length > 0 && /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      checked: areAllSelected,
      indeterminate: areSomeSelected,
      onChange: function onChange(e) {
        return handleToggleAll(e.target.checked);
      },
      sx: {
        padding: "0 4px"
      }
    }),
    label: "Select All (".concat(selectedCount, "/").concat(totalCount, " selected)"),
    sx: {
      margin: 0
    }
  }), showDivider && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    "data-testid": "tree-view-divider",
    sx: {
      borderBottom: "1px solid #E0E0E0",
      mb: 1
    }
  }), getAllTreeNodeIds(treeNodes).length === 0 ? /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      padding: 2,
      textAlign: "center",
      color: "text.secondary"
    }
  }, "No files available") : renderTreeNodes(treeNodes));
};